var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWinter = function SvgWinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004586",
    strokeWidth: 1.5,
    d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2-2h5M5 12h5m10.557-2.113-2.121 2.122m0 0 2.121 2.12M3.15 9.888l2.12 2.122m0 0-2.121 2.12M13 10.269l2.5-4.33m-7 12.124 2.5-4.33m3.449-10.2.776 2.899m0 0 2.898-.777M5.745 18.608l2.898-.776m0 0 .776 2.897M11 10.263l-2.5-4.33m7 12.124-2.5-4.33M5.892 5.641l2.897.776m0 0 .777-2.897m5.03 17.196.776-2.898m0 0 2.898.777",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgWinter as ReactComponent };
export default __webpack_public_path__ + "29b806323c9fe266b3657842dadbe4b2.svg";